var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-tab-item",
    { attrs: { active: _vm.active, title: "Detalle de Servicios" } },
    [
      _c("article", [
        _vm.selectedList.length > 0
          ? _c(
              "section",
              { staticClass: "container-fluid mb-4" },
              [
                _c("icon-view", {
                  attrs: {
                    gradient: "",
                    icon: "fa fa-file-invoice-dollar",
                    "icon-background": "#FF7058",
                    "icon-color": "#fff",
                    title: "Servicio(s) Seleccionado(s)"
                  }
                }),
                _vm._l(_vm.selectedList, function(item) {
                  return _c("row", {
                    key: `${item.visitSummaryId}-${item.serviceId}`,
                    attrs: {
                      action: {
                        name: "Remover",
                        icon: "fa-minus-circle",
                        variant: "outline-danger",
                        actionClick: () => {
                          _vm.$emit("update", item, true)
                        }
                      },
                      disable: _vm.disable,
                      item: item
                    }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        !_vm.disable
          ? _c(
              "section",
              { staticClass: "container-fluid mb-4" },
              [
                _c("icon-view", {
                  attrs: {
                    gradient: "",
                    icon: "fa fa-file-invoice-dollar",
                    "icon-background": "#FF7058",
                    "icon-color": "#fff",
                    title: "Servicios disponibles"
                  }
                }),
                _vm.availableList.length === 0
                  ? _c("div", { staticClass: "empty-content" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("No disponibles")
                      ])
                    ])
                  : _vm._e(),
                _vm._l(_vm.availableList, function(item) {
                  return _c("row", {
                    key: `${item.visitSummaryId}-${item.serviceId}`,
                    attrs: {
                      action: {
                        name: "Facturar",
                        icon: "fa-check",
                        variant: "outline-success",
                        actionClick: () => {
                          _vm.$emit("update", item, false)
                        }
                      },
                      disable: _vm.disable,
                      item: item
                    }
                  })
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm.disable && _vm.selectedList.length === 0
        ? _c("section", { staticClass: "container-fluid mb-4" }, [
            _c("div", { staticClass: "empty-content text-center" }, [
              _c("label", [
                _vm._v(
                  " No cuenta con servicios adicionales para facturar en este periodo. "
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }